var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgSent2 = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 24 24",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("path", {
    fill: props.color || 'currentColor',
    fillRule: "evenodd",
    d: "M2.04229758,14.0134155 C2.07728588,14.0120755 2.11254629,14.0088907 2.147973,14.0037818 L12.5770477,12.499828 C12.8228239,12.4643852 13.0052417,12.2537742 13.0052417,12.0054557 C13.0052417,11.7571372 12.8228239,11.5465262 12.5770477,11.5110834 L2.147973,10.0071295 C2.10678893,10.0011905 2.06528026,9.99782856 2.02368921,9.99706118 L1.99581944,3.98649511 C1.99072379,2.88193747 2.88199606,1.98236796 3.9865537,1.97722891 C4.30376444,1.97578069 4.61677523,2.04978519 4.89974217,2.19315365 L20.8707211,10.285034 C21.8560387,10.7842565 22.2500966,11.987714 21.7508741,12.9730316 C21.5568716,13.3559351 21.2448251,13.6662633 20.8608562,13.8581486 L4.96417492,21.8023813 C3.97611582,22.2961556 2.77485256,21.8954585 2.28107833,20.9073994 C2.14374204,20.6325848 2.07156244,20.3298253 2.07013906,20.0226083 L2.04229758,14.0134155 L2.04229758,14.0134155 Z"
  }));
};
export default SvgSent2;